import {EmailForm, ReportProgApiResponse} from "../reports/types";
import {useMutation, useQuery, useQueryClient} from "@tanstack/react-query";
import AxiosInstance from "../../components/Axios";
import AxiosInstanceUpload from "../../components/AxiosUpload";
import * as Yup from "yup";
import {Buffer} from "buffer";
import {MRT_ColumnFiltersState, MRT_PaginationState, MRT_SortingState} from "material-react-table";
import {mapJsonToReportProgApiResponse} from "../reports/types";



export function useGetReportProg(codprog :String) {
    return useQuery<ReportProgApiResponse>({
        queryKey: [
            'fetchReportProg',
        ],
        queryFn: async () => {

            const myURL = `?limit=200&offset=0&CODPROG__exact=${codprog}`;
            const response = await AxiosInstance.get(
                `reportprog/${myURL}`
            );

            return mapJsonToReportProgApiResponse(response.data);
        },
        refetchOnWindowFocus: false,
    });
}



export function useSendEmail() {
  return useMutation({
    mutationFn: async (emailForm: EmailForm) => {
      return AxiosInstance.post('sendemail/', emailForm);
    },
  });
}

export function useUploadReport() {
  return useMutation({
    mutationFn: async (formData: FormData) => {
      return AxiosInstanceUpload.post('uploadreport/', formData);
    },
  });
}

export const validationSchema = Yup.object().shape({
                      emailTo: Yup.string().email('Email non è valida'),
                    });


export async function jasperPrevBlob( formato: String) {
  try {
    const username = 'jasperadmin';
    const password = 'Tibco2024@';
    const base64encodedData = Buffer.from(`${username}:${password}`).toString('base64');

         let pag = '';
             if (formato === 'xlsx') {
                pag = 'ignorePagination=true&'
            }


    const response = await fetch(`${BASE_URL_JASPERSERVER}/rest_v2/reports/reports/prev${formato}.${formato}?${pag}`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/'+formato,
        'Authorization': `Basic ${base64encodedData}`,
      },
    });

    if (!response.ok) {
      throw new Error('Failed to fetch the report');
    }

    const blob = await response.blob();
    return blob;
  } catch (error) {
    console.error('Error generating report:', error);
    throw error; // Rethrow the error to handle it in the calling code if needed
  }
};

